var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c("AdministrationContinuousDataStations", {
        staticStyle: { "padding-top": "10px" },
        attrs: { name: _vm.name },
      }),
      _vm._v(" "),
      _c("AdministrationDiscreteSampleStations", {
        staticStyle: { "padding-top": "20px" },
        attrs: { name: _vm.name },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }